export default __webpack_public_path__ + "static/media/analytics.773c6aea.svg";